import get from 'lodash/get';
import { $http } from '../app.config';
import { africaOptions } from '../globals';

class DiscountCampaigns {
    /**
     * Searches campaign models
     *
     * @param {{tour: number, destination:number}} where
     * @return {Promise}
     */
    public search(where: { tour?: number, destination?: number }): Promise<any> {
        return new Promise((resolve, reject) => {
            $http
                .post(africaOptions.api.routes.discounts.search, where)
                .then((response: any) => {
                    if (get(response, 'data.success', false)) {
                        resolve(get(response, 'data.body', []));
                    } else {
                        reject(get(response, 'data.errors', []));
                    }
                });
        });
    }
}

const discountCampaigns = new DiscountCampaigns();

export default discountCampaigns;
